import { Box, Container, Link, Typography } from '@mui/material'
import Progress from '../Progress'
import { withAuthenticationRequired } from '@auth0/auth0-react'
import { Loading } from '../Loading'

const RedirectLoding = () => {
  return <Box>
    <Box display={"grid"} justifyContent={"center"}>
      <Box display={"flex"} justifyContent={"center"}>
        <Typography variant="h6" color="gray">リダイレクト中です...</Typography>
      </Box>
      <Box marginY={2}><Loading /></Box>
      <Box display={"flex"} justifyContent={"center"}>
        <Typography color="gray" sx={{ whiteSpace: 'pre-line', fontSize: 15 }}>
        ※現在システム障害によりiOS端末（iPhone / iPad）をご利用の場合、OSバージョンやブラウザ設定、 ネットワーク環境によりアクセスできない、または正しく表示されない場合があります。<br /><br />
        ※画面が切り替わらない場合はお手数ですがPC等、iOS以外の端末からアクセスしてください。<br /><br />
        ※本件に関するお問い合わせは<Link href="https://form.run/@miraiz-connect-nLYfeyfoxECC5kq4b4oK">こちら</Link>までお願いいたします。
        </Typography>
      </Box>
    </Box>
  </Box>
}

const RequestBase = () => {
  return (
    <Box>
      <Container maxWidth="xl">
        <Progress />
      </Container>
    </Box>
  )
}

export default withAuthenticationRequired(RequestBase, { onRedirecting: () => (<RedirectLoding />) })
